module.exports = __webpack_public_path__ + "static/przeplywy-stopnie-724972c33b443067406696f33c8159f7.png";